export default __webpack_public_path__ + "media/images/react_icons/calendar_filters_black-78d0f9dd9aea09b7d3d9937dbb84e55d.svg";